import React, { useState } from "react";
import { Play, X, ChevronRight } from "lucide-react";

const reels = [
  { id: 1, title: "Travel Vibes ✈️", thumbnail: "https://images.unsplash.com/photo-1506744038136-46273834b3fb?w=300&h=400&fit=crop" },
  { id: 2, title: "Cooking Tips 🍳", thumbnail: "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=300&h=400&fit=crop" },
  { id: 3, title: "Sunset Magic 🌅", thumbnail: "https://images.unsplash.com/photo-1495616811223-4d98c6e9c869?w=300&h=400&fit=crop" },
  { id: 4, title: "City Nights 🌃", thumbnail: "https://images.unsplash.com/photo-1519501025264-65ba15a82390?w=300&h=400&fit=crop" },
  { id: 5, title: "Nature Walk 🌿", thumbnail: "https://images.unsplash.com/photo-1441974231531-c6227db76b6e?w=300&h=400&fit=crop" },
  { id: 6, title: "Music Session 🎵", thumbnail: "https://images.unsplash.com/photo-1511379938547-c1f69419868d?w=300&h=400&fit=crop" },
];

const ReelSection = () => {
  const [activeReel, setActiveReel] = useState(null);
  const [showAllReels, setShowAllReels] = useState(false);

  console.log("Getting into Reel Section: ");

  return (
    <>
      {/* Reels Container */}
      <div
        className="animate-slide-up rounded-xl border border-border bg-card p-6"
        style={{ width: "100%", border: "1px solid var(--border-color, rgb(52, 51, 51))" }}
      >
        <h3 className="mb-3 text-sm font-semibold text-foreground">Reels</h3>
        <div className="flex gap-3 overflow-x-auto pb-2 scrollbar-hide" style={{gap: 5}}>
          {reels.map((reel) => (
            <button
              key={reel.id}
              onClick={() => setActiveReel(reel)}
              className="relative flex-shrink-0 group"
            >
              {/* Reel Thumbnail */}
              <img
                src={reel.thumbnail}
                alt={reel.title}
                className="h-36 w-24 rounded-lg object-cover border border-border transition-transform group-hover:scale-105"
              />

              {/* Play Button Overlay */}
              <div className="absolute inset-0 flex items-center justify-center rounded-lg bg-background/40 opacity-0 transition-opacity group-hover:opacity-100">
                <Play size={24} className="text-foreground" fill="currentColor" />
              </div>

              {/* Reel Title */}
              <p className="absolute bottom-1.5 left-1.5 right-1.5 truncate text-[10px] font-medium text-foreground drop-shadow-md">
                {reel.title}
              </p>
            </button>
          ))}

          {/* Show All Button */}
          <button
            onClick={() => setShowAllReels(true)}
            className="relative flex-shrink-0 group h-36 w-24"
          >
            <div className="h-36 w-24 rounded-lg border-2 border-dashed border-border bg-background/50 flex items-center justify-center transition-all group-hover:bg-background/70 group-hover:border-foreground/50">
              <div className="flex flex-col items-center gap-1">
                <ChevronRight size={20} className="text-foreground/70" />
                <p className="text-[10px] font-medium text-foreground/70">Show All</p>
              </div>
            </div>
          </button>
        </div>
      </div>

      {/* Reel Player Modal */}
      {activeReel && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-background/80 backdrop-blur-sm"
          onClick={() => setActiveReel(null)}
        >
          <div
            className="animate-scale-in relative w-full max-w-sm rounded-2xl border border-border bg-card overflow-hidden"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Close Button */}
            <button
              onClick={() => setActiveReel(null)}
              className="absolute right-3 top-3 z-10 rounded-full bg-background/60 p-1.5 text-foreground hover:bg-background transition-colors"
            >
              <X size={18} />
            </button>

            {/* Reel Image */}
            <img
              src={activeReel.thumbnail}
              alt={activeReel.title}
              className="aspect-[9/16] w-full object-cover"
            />

            {/* Reel Info Overlay */}
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-background/90 to-transparent p-4">
              <p className="text-sm font-semibold text-foreground">{activeReel.title}</p>
              <p className="text-xs text-muted-foreground">Playing...</p>
            </div>
          </div>
        </div>
      )}

      {/* Show All Reels Modal */}
      {showAllReels && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-background/80 backdrop-blur-sm p-4"
          onClick={() => setShowAllReels(false)}
        >
          <div
            className="animate-scale-in relative w-full max-w-4xl max-h-[90vh] rounded-2xl border border-border bg-card overflow-hidden flex flex-col"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Modal Header */}
            <div className="flex items-center justify-between border-b border-border p-4">
              <h2 className="text-lg font-semibold text-foreground">All Reels</h2>
              <button
                onClick={() => setShowAllReels(false)}
                className="rounded-full bg-background/60 p-1.5 text-foreground hover:bg-background transition-colors"
              >
                <X size={20} />
              </button>
            </div>

            {/* Reels Grid */}
            <div className="overflow-y-auto flex-1 p-6">
              <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
                {reels.map((reel) => (
                  <button
                    key={reel.id}
                    onClick={() => {
                      setActiveReel(reel);
                      setShowAllReels(false);
                    }}
                    className="relative group flex-shrink-0"
                  >
                    {/* Reel Thumbnail */}
                    <img
                      src={reel.thumbnail}
                      alt={reel.title}
                      className="w-full aspect-[9/16] rounded-lg object-cover border border-border transition-transform group-hover:scale-105"
                    />

                    {/* Play Button Overlay */}
                    <div className="absolute inset-0 flex items-center justify-center rounded-lg bg-background/40 opacity-0 transition-opacity group-hover:opacity-100">
                      <Play size={32} className="text-foreground" fill="currentColor" />
                    </div>

                    {/* Reel Title */}
                    <p className="absolute bottom-2 left-2 right-2 truncate text-xs font-medium text-foreground drop-shadow-md">
                      {reel.title}
                    </p>
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ReelSection;
